module.exports = __webpack_public_path__ + "static/media/add-contact.da0ab2ed.svg";